import React, { useRef, useState, useEffect } from "react";
import Cards from "../../components/AdminSideComponents/Cards";
import AnalyticsIcon1 from "../../Assets/Logos/checkout/AnalyticsIcon1.png";
import AnalyticsIcon2 from "../../Assets/Logos/checkout/AnalyticsIcon2.png";
import AnalyticsIcon3 from "../../Assets/Logos/checkout/AnalyticsIcon3.png";
import AnalyticsIcon4 from "../../Assets/Logos/checkout/AnalyticsIcon4.png";

import checkoutIcon from "../../Assets/Logos/checkout/checkoutIcon.png";
import deleteIcon from "../../Assets/Logos/checkout/deleteIcon.png";
import addNoticeIcon from "../../Assets/Logos/notice/addNoticeIcon.png";

import { useNavigate } from "react-router-dom";
import { FaEllipsisH, FaSearch, FaTimes } from "react-icons/fa";
import CheckOutModal from "../../components/AdminSideComponents/CheckOutModal";
import axios from "axios";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import ViewCheckOutModal from "../../components/AdminSideComponents/ViewCheckOutModal";
import { formatDate } from "../../utils/dateFormat";

// dummy data for analytics cards  at top...
const items = [
  { name: "Number of Beds Vacant", numberOfItems: 350, icon: AnalyticsIcon1 },
  { name: "Total number of Beds", numberOfItems: 10, icon: AnalyticsIcon2 },
  { name: "Number of Beds Booked", numberOfItems: 80, icon: AnalyticsIcon3 },
  { name: "Number Of Notices", numberOfItems: 120, icon: AnalyticsIcon4 },
];

const CheckOuts = () => {
  const [showDropdown, setShowDropdown] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState({});
  const [hostelName, setHostelName] = useState(""); //State for filtering by hostel name
  const [checkOut, setCheckOut] = useState([]);
  const navigate = useNavigate();
  const dropdownRefs = useRef([]);
  const itemsPerPage = 10;
  const [isViewCheckOutModalOpen, setIsViewCheckOutModalOpen] = useState(false);
  const [selectedCheckOut, setSelectedCheckOut] = useState({});
  const [allBuildings, setAllBuildings] = useState([]);

  const [isModalOpen, setModalOpen] = useState(false);

  const [dropdownPosition, setDropdownPosition] = useState("down");

  const toggleDropdown = (index) => {
    // Get the position of the dropdown element to determine where it should open
    const dropdownElement = dropdownRefs.current[index];
    if (dropdownElement) {
      const rect = dropdownElement.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      console.log("myValues :", spaceBelow, spaceAbove);
      console.log("myElement", rect);
      // Set dropdown position based on available space
      if (spaceBelow < 200 && spaceAbove > 150) {
        setDropdownPosition("up");
      } else {
        setDropdownPosition("down");
      }
    }

    // Toggle the dropdown visibility, close it if already open
    setShowDropdown((prev) => (prev === index ? null : index));
  };

  const closeDropdownOnOutsideClick = (event) => {
    if (
      !dropdownRefs.current.some((ref) => ref && ref.contains(event.target))
    ) {
      setShowDropdown(null); // Close any open dropdowns
    }
  };

  useEffect(() => {
    document.addEventListener("click", closeDropdownOnOutsideClick);
    return () => {
      document.removeEventListener("click", closeDropdownOnOutsideClick);
    };
  }, []);

  //Function to fetch all buildings
  const fetchAllBuildings = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/resources/get_all_building`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("fhghgjgj---->", response.data.data);
        setAllBuildings(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchAllBuildings();
  }, []);

  const getAllCheckOut = (page) => {
    setLoading(true);
    const tenantStatus = "Check Out";
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/check_in/get_check_in_paginated?page=${page}&limit=${itemsPerPage}&search=${searchQuery}&tenantStatus=${tenantStatus}&hostelName=${hostelName}`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        console.log("Checkout------>", response.data);
        setCheckOut(response.data.data);
        setLoading(false);
        setPagination(response.data.pagination);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      getAllCheckOut(currentPage);
    }, 800); // Waits for 500ms of inactivity
    return () => clearTimeout(timeout);
  }, [currentPage, searchQuery, hostelName]);

  // const toggleDropdown = (index) => {
  //   setShowDropdown(showDropdown === index ? null : index);
  // };

  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const goToNextPage = () => {
    if (currentPage < pagination.totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  return (
    <div className="chekoutConatinaer p-6 bg-primarybgColor ">
      <h1 className="text-primaryTextColor text-[25px] sm:text-[32px] font-bold mb-6">
        Check Out
      </h1>
      {/* <Cards items={items} /> */}

      <div className="p-4 bg-white shadow-lg mt-6 rounded-lg overflow-hidden ">
        <div className="flex w-full  overflow-hidden justify-evenly flex-wrap  md:justify-between items-center gap-4  mb-4">
          <h1 className="text-[18px] min-w-fit  text-primaryTextColor sm:text-[24px] font-bold">
            Check Out Lists
          </h1>

          <div className="relative flex items-center   gap-3">
            <div className="relative   ">
              <input
                type="text"
                placeholder="Search..."
                className="border border-gray-300 w-[100%] lg:w-auto rounded-lg p-2 pl-8 pr-8 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                value={searchQuery}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchQuery(e.target.value);
                }}
              />
              <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-secondaryTextColor" />

              {searchQuery && (
                <FaTimes
                  onClick={clearSearch}
                  className="absolute right-3 top-1/2 transform -translate-y-1/2 text-secondaryTextColor cursor-pointer"
                />
              )}
            </div>

            {/* Filtering Check-outs using building names */}
            <div>
              <select
                name=""
                id=""
                className="border border-gray-300 w-[100%] lg:w-auto rounded-lg p-2 pl-8 pr-8 text-primaryTextColor focus:outline-none focus:ring focus:ring-blue-200"
                onChange={(e) => setHostelName(e.target.value)}
              >
                <option value="">Select Building</option>
                {allBuildings.length > 0 ? (
                  allBuildings.map((building, index) => (
                    <option key={index} value={building._id}>
                      {building.nameBuilding}
                    </option>
                  ))
                ) : (
                  <option disabled>No Buildings found</option>
                )}
              </select>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto  min-h-[70vh]">
          <table className="min-w-[90vw]  bg-white  border-gray-200 rounded-md  ">
            <thead>
              <tr className="bg-gray-100 rounded-r-xl ">
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor rounded-l-xl">
                  Name
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Mobile No / Email
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Room No
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Bed No
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Building Name
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Reason of Checkout
                </th>

                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor">
                  Joining Date
                </th>
                <th className="py-3 px-6 text-center text-[14px] font-semibold text-primaryTextColor rounded-r-xl ">
                  CheckOut Date
                </th>
              </tr>
            </thead>
            <tbody className="font-medium text-[13px] text-[#202224] tracking-wide ">
              {loading ? (
                // Skeleton Loader
                [...Array(10)].map((_, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 animate-pulse"
                  >
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-3/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/2"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/4"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/3"></div>
                    </td>
                    <td className="py-4 px-6">
                      <div className="h-4 text-center bg-gray-300 rounded w-1/4"></div>
                    </td>
                  </tr>
                ))
              ) : checkOut?.length > 0 ? (
                checkOut.map((data, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50"
                  >
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.name}
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.mobile}
                      <br />
                      <span className="text-secondaryTextColor">
                        {data?.email}
                      </span>
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.roomId?.roomNumber}
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.bedId?.bedNumber}
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {data?.hostelName?.nameBuilding}
                    </td>
                    <td className="py-4 px-6  text-sm text-center text-primaryTextColor">
                      {data?.notice?.UnderNotice ? (
                        <span className="flex justify-center gap-2">
                          {data?.notice?.reasonOfNotice.slice(0, 10)}...
                          <MdOutlineRemoveRedEye
                            className="w-4 h-4 cursor-pointer "
                            onClick={() => {
                              setSelectedCheckOut(data);
                              setIsViewCheckOutModalOpen(true);
                            }}
                          />
                        </span>
                      ) : (
                        "N/A"
                      )}
                    </td>

                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {formatDate(data?.joiningDate)}
                    </td>
                    <td className="py-4 px-6 text-sm text-center text-primaryTextColor">
                      {formatDate(data?.checkOutDate)}
                    </td>
                    {/* <td className="py-4 px-6 text-sm text-center hover:text-primaryTextColor text-secondaryTextColor  mt-4 relative ">
                        <div
                          className="relative "
                          ref={(el) => (dropdownRefs.current[index] = el)}
                        >
                          <FaEllipsisH
                            size={25}
                            className="cursor-pointer"
                            onClick={() => toggleDropdown(index)}
                          />
                          {showDropdown === index && (
                            <div className="z-30 absolute  right-0    mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg">
                              <ul className="py-1">
                                <li
                                  onClick={() => setModalOpen(true)}
                                  className="text-gray-900 flex gap-2 items-center hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm"
                                >
                                  <img
                                    src={checkoutIcon}
                                    className="h-4 w-4"
                                    alt="checkout"
                                  />{" "}
                                  Check Out
                                </li>
                                <li className="text-gray-900 flex gap-2 items-center  hover:bg-gray-100 cursor-pointer px-4 py-2 text-sm">
                                  <img
                                    src={deleteIcon}
                                    className="h-4 w-4"
                                    alt="checkout"
                                  />{" "}
                                  Delete
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                      </td> */}
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="9"
                    className="py-40 px-6 text-lg text-center text-secondaryTextColor"
                  >
                    No Checkouts available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>

        <div className="flex justify-between items-center mt-4">
          <p className="text-sm text-secondaryTextColor">
            Showing {itemsPerPage * (currentPage - 1) + 1}-
            {Math.min(itemsPerPage * currentPage, pagination.totalCheckIns)} of{" "}
            {pagination.totalCheckIns}
          </p>
          <div className="flex space-x-2">
            <button
              className={`${
                currentPage === 1 ? "bg-gray-300" : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToPreviousPage}
              disabled={currentPage === 1}
            >
              ←
            </button>
            <button
              className={`${
                currentPage === pagination.totalPages
                  ? "bg-gray-300"
                  : "bg-secondaryTextColor"
              } text-gray-600 px-3 py-1 rounded-lg`}
              onClick={goToNextPage}
              disabled={currentPage === pagination.totalPages}
            >
              →
            </button>
          </div>
        </div>
      </div>

      <ViewCheckOutModal
        isOpen={isViewCheckOutModalOpen}
        onClose={() => setIsViewCheckOutModalOpen(false)}
        data={selectedCheckOut}
      />
    </div>
  );
};

export default CheckOuts;
